import React from 'react';
import { cn } from '@/lib/utils';
import { Campaign } from '@/types/campaign';

interface CampaignStatusBadgeProps {
  status: Campaign['status'];
  className?: string;
}

const statusConfig: Record<Campaign['status'], { label: string; className: string }> = {
  draft: {
    label: 'Draft',
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  },
  submitted: {
    label: 'Submitted',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  packaging: {
    label: 'Packaging',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  presented: {
    label: 'Presented',
    className: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  },
  hold: {
    label: 'On Hold',
    className: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  confirmed: {
    label: 'Confirmed',
    className: 'bg-green-100 text-green-800 border-green-200',
  },
  active: {
    label: 'Active',
    className: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  },
  delivered: {
    label: 'Delivered',
    className: 'bg-teal-100 text-teal-800 border-teal-200',
  },
  complete: {
    label: 'Complete',
    className: 'bg-gray-800 text-white border-gray-700',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'bg-red-100 text-red-800 border-red-200',
  },
};

export const CampaignStatusBadge: React.FC<CampaignStatusBadgeProps> = ({ status, className }) => {
  const config = statusConfig[status] || statusConfig.draft;

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};
